import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/useEntity';
import { ProductosList } from '../productos/ProductosList';
import { NuevosProductosList } from '../nuevos-productos/NuevosProductosList';
import { PedidosClienteList } from '../pedidos-cliente/PedidosClienteList';
import { CotizacionesList } from '../game/CotizacionesList';
import { GameCalculadora } from '../game/GameCalculadora';
import { PageHeader } from '../../components/ui/PageHeader';
import { Card } from '../../components/ui/Card';

const CLIENTE = 'TICNOVA';

function ComingSoon({ titulo }: { titulo: string }) {
  return (
    <div>
      <PageHeader title={titulo} subtitle="Sección pendiente." />
      <Card>
        <p className="text-sm text-slate-600">Próximamente.</p>
      </Card>
    </div>
  );
}

export function TicnovaDashboard() {
  return (
    <div>
      <PageHeader
        title="Dashboard TICNOVA"
        subtitle="Resumen operativo del cliente TICNOVA."
      />
      <Card>
        <p className="text-sm text-slate-600">
          Pendiente de definir. KPIs operativos de TICNOVA: marcas Netway,
          Netway Gaming, Innobo.
        </p>
      </Card>
    </div>
  );
}

export function TicnovaProductos() {
  return <ProductosList clienteCodigo={CLIENTE} title="Productos TICNOVA" subtitle="Catálogo consolidado de productos comercializados a TICNOVA." />;
}

export function TicnovaNuevosProductos() {
  return <NuevosProductosList clienteCodigo={CLIENTE} title="Proyectos / Ideas — TICNOVA" subtitle="Briefings de búsqueda para incorporar nuevos productos al catálogo de TICNOVA." />;
}

export function TicnovaCalculadora() {
  return <GameCalculadora clienteCodigo={CLIENTE} />;
}

export function TicnovaCotizaciones() {
  return (
    <CotizacionesList
      clienteCodigo={CLIENTE}
      title="Cotizaciones TICNOVA"
      calcRoute="/ticnova/calculadora"
    />
  );
}

export function TicnovaPedidos() {
  const clientes = useQuery({
    queryKey: ['list', '/admin/clientes'],
    queryFn: () => api.get<{ data: Array<{ id: string; codigo: string }> }>('/admin/clientes'),
  });
  const clienteId = clientes.data?.data?.find((c) => c.codigo === CLIENTE)?.id ?? null;
  return (
    <PedidosClienteList
      clienteCodigo={CLIENTE}
      clienteId={clienteId}
      title="Pedidos TICNOVA"
      subtitle="Pedidos del cliente TICNOVA."
    />
  );
}

// TicnovaImportador vive en su propio módulo (carga exceljs) y App.tsx lo
// importa con lazy(), igual que el importador semanal de GAME.
export const TicnovaParametros = () => <ComingSoon titulo="Parámetros TICNOVA" />;
